import { apiAuth } from "../../http";

export const getHighLightById = async (id: string): Promise<any> => {
  const response = apiAuth()
    .get(`/highlights/${id}`)
    .then(({ data }) => data);
  return response;
};
